module.exports = __webpack_public_path__ + "static/scale-model-of-landing-green-park-in-san-mateo-california-88d254029fc1fadb4e6f61dc9518f5f3.png";